import Vomo from './vomo'

export default Vomo